import sortBy from "lodash/sortBy"

const PATHS = Object.entries({
  premium: ["19-premium-offer", "19-premium-paymodes", "19-premium-thank-you"],
  shopping_list: ["20-sl-offer", "20-sl-paymodes", "20-sl-thank-you"],
  shopping_list_and_premium: [
    "21-sl-and-premium-offer",
    "21-sl-and-premium-paymodes",
    "21-sl-and-premium-thank-you",
  ],
  basic_annual: ["22-basic-annual-offer", "22-basic-annual-paymodes", "22-basic-annual-thank-you"],
}).reduce(
  (paths, [type, rawPaths]) => ({
    ...paths,
    [type]: rawPaths.map(
      (rawPath) =>
        `${pipelineConfig.pathPrefix}${
          pipelineConfig.variants[pipelineConfig.variant].pagePaths[rawPath]
        }/`
    ),
  }),
  {}
)

export default (upsellOfferType) => ({
  initUpsell() {
    if (upsellOfferType && this.isOfferPath()) {
      this.store.clearPrimerSession()
    }

    this.store.values.skippedUpsellOffers = this.store.values.skippedUpsellOffers.filter(
      (type) => type !== upsellOfferType
    )

    const upsell = pipelineConfig.offers.find(
      (offer) => offer.type && offer.type.toLowerCase() === upsellOfferType
    )

    if (!upsell) return

    this.store.values.activeOffer = upsell
  },

  isOfferPath() {
    return window.location.pathname === PATHS[upsellOfferType][0]
  },

  getThankYouPath() {
    return PATHS[upsellOfferType][2]
  },

  getNextUpsellOfferPath() {
    const upsellOffers = sortBy(
      pipelineConfig.offers.filter((offer) => offer.type && offer.type.toLowerCase() !== "basic"),
      "customData.sequence"
    )

    if (!upsellOfferType) return PATHS[upsellOffers[0].type.toLowerCase()][0]

    const currentUpsellOfferIndex = upsellOffers.findIndex(
      (upsellOffer) => upsellOffer.type.toLowerCase() === upsellOfferType
    )

    const nextUpsellOffer = upsellOffers[currentUpsellOfferIndex + 1]

    let type
    if (nextUpsellOffer?.type.toLowerCase() === "shopping_list_and_premium") {
      if (
        this.store.values.skippedUpsellOffers.includes("premium") &&
        this.store.values.skippedUpsellOffers.includes("shopping_list")
      ) {
        type = nextUpsellOffer.type.toLowerCase()
      } else {
        type = upsellOffers[currentUpsellOfferIndex + 2]?.type.toLowerCase()
      }
    } else {
      type = nextUpsellOffer?.type.toLowerCase()
    }

    if (type) {
      return PATHS[type][0]
    } else {
      return `${pipelineConfig.pathPrefix}${
        pipelineConfig.variants[pipelineConfig.variant].pagePaths["23-send-off"]
      }`
    }
  },

  async goToNextUpsellOffer(skip = false) {
    if (skip && upsellOfferType) {
      const skippedOffer = pipelineConfig.offers.find(
        (offer) => offer.type && offer.type.toLowerCase() === upsellOfferType
      )

      this.store.values = {
        ...this.store.values,
        skippedUpsellOffers: [...this.store.values.skippedUpsellOffers, upsellOfferType],
      }

      if (skippedOffer) await this.store.push(false, skippedOffer.brandOfferId)
    }

    window.location = this.store.addTokenHashParam(this.getNextUpsellOfferPath())
  },

  goToThankYou(response) {
    let url = PATHS[upsellOfferType][2]
    if (response) {
      url = this.store.addTokenHashParam(
        `${PATHS[upsellOfferType][2]}?${this.store.buildUrlParamsForThankYou(response).toString()}`
      )
    }
    window.location = url
  },

  goToPaymodes() {
    window.location = this.store.addTokenHashParam(PATHS[upsellOfferType][1])
  },

  async purchase() {
    this.loading = true

    const response = await this.store.payOrCreateSession()
    await this.store.trackViewAndMaybeStatus("INITIATE_CHECKOUT")

    if (response.instantlyCharged) {
      this.goToThankYou(response)
    } else {
      this.goToPaymodes()
    }
  },
})
